import React from "react";

export default function SimpleStats() {
  return <>SimpleStats</>;
}
